export const controlButtonSx = {
  color: 'black',
  '&:hover': {
    bgcolor: 'rgba(255, 255, 255, 0.2)'
  },
  '&:disabled': {
    color: 'rgba(0, 0, 0, 0.5)'
  }
}

export const controlBarSx = {
  display: 'flex',
  gap: 0.5,
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  borderRadius: 1,
  padding: '4px'
}

/** Texto só para leitores de tela. */
export const visuallyHiddenSx = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0
} as const

export const MIN_CONTRAST = 0.5
export const MAX_CONTRAST = 2
export const CONTRAST_STEP = 0.1
